/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Button from 'material-ui/Button';
/* eslint-enable import/no-extraneous-dependencies */
import Link from 'gatsby-link';
import classnames from 'classnames/bind';

import styles from './postCard.module.css';

const cx = classnames.bind(styles);

const PostListingCard = ({ post, index = 0, color }) => ([
  <article className={cx('postPreviewCard', { alt: (index % 2 === 1) })} key={`Post${post.id}`}>
    <div key="postHeader" className={styles.postHeader}>
      <Link className={styles.postTitle} to={post.frontmatter.path}>
        <h1>{post.frontmatter.title}</h1>
      </Link>
      <div className={styles.postSubHeader}>
        {`
          ${post.frontmatter.date}
          /
          ${post.frontmatter.tags.join(', ')}
          `}
      </div>
    </div>
    <div key="postLetter" className={styles.postLetter}>{post.frontmatter.title[0]}</div>
    <div key="postContent" className={styles.postContent}>
      <p>{post.frontmatter.description}</p>
      <Link className={styles.readMoreButton} to={post.frontmatter.path}>
        <Button raised color="primary" className={cx(color)}>
                  Read More ...
        </Button>
      </Link>
    </div>
  </article>,
  <hr key="hr" className="horizontalLine" />,
]);

export default PostListingCard;



// WEBPACK FOOTER //
// ./src/components/PostListingCard/index.jsx